import { InjectionToken } from '@angular/core';
import { IAccountSessionRepository } from '../repositories/account-session.repository';

export const ACCOUNT_SESSION_REPOSITORY = new InjectionToken<IAccountSessionRepository>(
  'ACCOUNT_SESSION_REPOSITORY'
);
